module.exports = __webpack_public_path__ + "static/media/TAS.64e2b4b6.svg";